// extracted by mini-css-extract-plugin
module.exports = {"header":"_1CIOMe","fixed":"D3yhYP","content":"XN1gTI","backdrop":"_2XlMtM","withShadow":"_3Uz0Mw"};